import { ALLOWED_CONSTANTS } from '../models/Filter';

// Generate under-price slug manifest entries programmatically
const UNDER_PRICE_TYPES = [
  { prefix: 'houses', propertyTypes: ['house'] },
  { prefix: 'apartments', propertyTypes: ALLOWED_CONSTANTS.defaultPropertyTypes },
  { prefix: 'condos', propertyTypes: ['condo'] },
];
const PRICE_POINTS = [500, 1000, 1500, 2000, 2500, 3000];

const underPriceSlugs: Record<
  string,
  {
    filter: { listingTypes: Array<string>; propertyTypes: Array<string> | ReadonlyArray<string>; highPrice: number };
    excludeAreaTypes: Array<string>;
    seoApiKeyword: string;
  }
> = {};
for (const { prefix, propertyTypes } of UNDER_PRICE_TYPES) {
  for (const price of PRICE_POINTS) {
    underPriceSlugs[`${prefix}-under-${price}`] = {
      filter: { listingTypes: ['rental'], propertyTypes, highPrice: price },
      excludeAreaTypes: [],
      seoApiKeyword: '',
    };
  }
}

// TODO: remove file since searchSlugs are generated on the BE

/****************
    searchSlugObject:
     'search-slug-name': {                      // Name of search slug that will be active.
        filter: {
            listingTypes: [Array],  // Array of listing types related to slug. e.g., ['rental', 'sublet', 'room']
            propertyTypes: [Array]  // Array of property types to fetch for a particular slug. e.g., ['house', 'townhouse']
        },
        excludeAreaTypes: [],   // Exclude this slug from certain area (e.g., University area type is consolidated slugs
        seoApiKeyword: 'house', // keyword used for fetching nearby area links for SEO footer, may be different that filter.propertyTypes above.
    }

    DEPRECATED SLUGS:
    If / when slugs are deprecated from activeSearchSlugs, they should be
    added to the the deprecatedSlugs object at bottom of file.
    where key === deprecated slug and value === redirect slug:
    e.g., { 'old-humble-abodes-for-rent': 'apartments-for-rent' }
*****************/

const activeSearchSlugs = {
  /*
    'cheap-vegan-apartments-for-rent': {
        filter: {
            listingTypes: Filter.allowedConstants.defaultListingTypes,
            propertyTypes: Filter.allowedConstants.defaultPropertyTypes
        },
        excludeAreaTypes: [],
        seoApiKeyword: 'vegan'
    },
    */
  'apartments-for-rent': {
    filter: {
      listingTypes: ALLOWED_CONSTANTS.defaultListingTypes,
      propertyTypes: ALLOWED_CONSTANTS.defaultPropertyTypes,
    },
    excludeAreaTypes: [],
    seoApiKeyword: 'rental, sublet, room',
  },
  'affordable-apartments-for-rent': {
    filter: {
      listingTypes: ['rental'],
      propertyTypes: ALLOWED_CONSTANTS.defaultPropertyTypes,
      orderBy: 'lowPrice',
    },
    excludeAreaTypes: [],
    seoApiKeyword: 'affordableApartment',
  },
  'affordable-houses-for-rent': {
    filter: {
      listingTypes: ['rental'],
      propertyTypes: ALLOWED_CONSTANTS.defaultPropertyTypes,
      orderBy: 'lowPrice',
    },
    excludeAreaTypes: [],
    seoApiKeyword: 'affordableHouse',
  },
  'pet-friendly-apartments-for-rent': {
    filter: {
      listingTypes: ['rental'],
      propertyTypes: ALLOWED_CONSTANTS.defaultPropertyTypes,
      pets: ['cats', 'dogs'],
    },
    excludeAreaTypes: [],
    seoApiKeyword: 'petFriendlyApartment',
  },
  'condos-for-rent': {
    filter: {
      listingTypes: ALLOWED_CONSTANTS.defaultListingTypes,
      propertyTypes: ['condo'],
    },
    excludeAreaTypes: ['university'],
    seoApiKeyword: 'condo',
  },
  'houses-for-rent': {
    filter: {
      listingTypes: ALLOWED_CONSTANTS.defaultListingTypes,
      propertyTypes: ['house', 'townhouse'],
    },
    excludeAreaTypes: [],
    seoApiKeyword: 'house',
  },
  'townhomes-for-rent': {
    filter: {
      listingTypes: ALLOWED_CONSTANTS.defaultListingTypes,
      propertyTypes: ['townhouse'],
    },
    excludeAreaTypes: [],
    seoApiKeyword: 'townhouse',
  },
  sublets: {
    filter: {
      listingTypes: ['sublet'],
      propertyTypes: ALLOWED_CONSTANTS.defaultPropertyTypes,
    },
    excludeAreaTypes: [],
    seoApiKeyword: 'sublet',
  },
  'student-housing': {
    filter: {
      listingTypes: ALLOWED_CONSTANTS.defaultListingTypes,
      propertyTypes: ALLOWED_CONSTANTS.defaultPropertyTypes,
      studentHousing: true,
    },
    excludeAreaTypes: [],
    seoApiKeyword: 'studentHousing',
  },
  ...underPriceSlugs,
};

// Redirect deprecated search slugs.
// Ensure deprecated slug is removed from above.
// [old-slug] : [new-slug]
const deprecatedSlugs = {
  'corporate-housing': 'apartments-for-rent',
  'duplexes-for-rent': 'apartments-for-rent',
  'homes-for-sale': 'apartments-for-rent',
  'condos-for-sale': 'apartments-for-rent',
  'land-for-sale': 'apartments-for-rent',
  'duplexes-for-sale': 'apartments-for-rent',
  'townhomes-for-sale': 'apartments-for-rent',
  'cheap-apartments-for-rent': 'affordable-apartments-for-rent',
  'cheap-houses-for-rent': 'affordable-houses-for-rent',
  'sublets-for-rent': 'sublets',
};

export default {
  activeSearchSlugs,
  deprecatedSlugs,
};
